import PropTypes from 'prop-types';
import { css } from 'twin.macro';
import { AiOutlineClose } from 'react-icons/ai';
import { MdLocationOff, MdLocationOn } from 'react-icons/md';
import { VscLoading } from 'react-icons/vsc';
import { debounce } from '../../../_helpers';

const mapSearch = css`
    position: absolute;
    top: 2%;
    right: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
`;

const searchInput = css`
    width: 100%;
    background-color: #fff;
    font-size: 1.5rem;
    background-image: url('https://cdn2.iconfinder.com/data/icons/ios-7-icons/50/search-20.png');
    background-position: 100% 50%;
    background-repeat: no-repeat;
    padding: 1rem 2rem 1rem 1rem;
    outline: none;
    padding-left: 8%;
    border-radius: 30px;
    border: none;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const searchDropdown = css`
    width: 26%;
    max-height: 50vh;
    overflow: auto;
    border-radius: 5px;
    background-color: white;
    display: flex;
    align-self: center;
    flex-direction: column;
    box-shadow: 0 4px 5px rgb(0 0 0 / 30%);
    border-top: 0.05px solid rgb(0 0 0 / 20%);
    margin-top: 39px;
`;

const dropdownRow = css`
    cursor: pointer;
    text-align: start;
    :hover {
        background-color: #ededed;
    }
`;

const searchItem = css`
    display: flex;
    padding: 1% 2% 0% 4%;
    span {
        padding-right: 3%;
        margin-top: -2px;
    }
    svg {
        fill: #70757a !important;
    }
`;

const iconButton = css`
    outline: none;
    color: #555;
    padding: 0 1rem 0 0;
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    border: none;
    background: transparent;
    border-radius: 30px;
    svg {
        transition: transform 250ms;
    }
    :hover > svg {
        transform: scale(1.2);
    }
`;

const closeButton = css`
    outline: none;
    color: #191919;
    padding: 0 1rem 0 0;
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    border: none;
    background: transparent;
    border-radius: 30px;
    svg {
        transition: transform 250ms;
    }
    :hover > svg {
        transform: scale(1.2);
    }
`;

const MapSearchControl = ({
    inputRef,
    showRealEstate,
    showPlaces,
    searchLoading,
    search,
    searchMode,
    setSearchMode,
    handleMapSearch,
    clearSearch,
    filteredResults,
    onMapSearch,
}) => (
    <div css={mapSearch}>
        <div onChange={debounce(handleMapSearch, 300)}>
            <div
                css={css`
                    width: 26%;
                    display: flex;
                    border: 3px solid #50aeb0;
                    border-radius: 30px;
                    background: white;
                    position: absolute;
                    left: 50%;
                    right: 50%;
                    transform: translate(-50%, -50%);
                    margin-top: 15px;
                `}
            >
                <input
                    placeholder={
                        showRealEstate
                            ? 'Ask Bob: multifamily for sale under $1M...'
                            : showPlaces
                              ? 'Search pizza, coffee, gym near me...'
                              : 'Search places, teams, or ask Bob...'
                    }
                    css={searchInput}
                    ref={inputRef}
                />
                {searchLoading ? (
                    <div
                        css={css`
                            margin: 6px 12px 0 0;
                        `}
                    >
                        <VscLoading className="spin" />
                    </div>
                ) : search?.length >= 1 ? (
                    <button css={closeButton} onClick={clearSearch} disabled={searchLoading}>
                        <AiOutlineClose />
                    </button>
                ) : (
                    <button
                        css={iconButton}
                        onClick={() =>
                            setSearchMode((prev) => ({ locations: 'channels', channels: 'locations' })[prev])
                        }
                        disabled={searchLoading}
                    >
                        {searchMode === 'locations' ? <MdLocationOn /> : <MdLocationOff />}
                    </button>
                )}
            </div>
        </div>

        {filteredResults?.length > 0 && (
            <div css={searchDropdown}>
                {filteredResults.map((result) => (
                    <div onClick={() => onMapSearch(result)} css={dropdownRow} key={result._id}>
                        {result.addresses?.length > 0 && (
                            <div css={searchItem}>
                                <span>
                                    <MdLocationOn />
                                </span>
                                <p>{result.title}</p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        )}
    </div>
);

MapSearchControl.propTypes = {
    inputRef: PropTypes.shape({ current: PropTypes.any }),
    showRealEstate: PropTypes.bool,
    showPlaces: PropTypes.bool,
    searchLoading: PropTypes.bool,
    search: PropTypes.string,
    searchMode: PropTypes.string,
    setSearchMode: PropTypes.func,
    handleMapSearch: PropTypes.func,
    clearSearch: PropTypes.func,
    filteredResults: PropTypes.arrayOf(PropTypes.object),
    onMapSearch: PropTypes.func,
};

export default MapSearchControl;
